export default __webpack_public_path__ + "static/media/icon-polygons.2ca264ef.svg";